/**
 * Pure URL-splitting helper shared by LinkifiedText. Kept free of any
 * react-native imports so it can be unit-tested in the node vitest environment.
 */

// Split on http(s) URLs, keeping the URLs as capture groups so the returned
// array alternates [text, url, text, url, ...].
const URL_SPLIT = /(https?:\/\/[^\s]+)/gi;
const URL_TEST = /^https?:\/\//i;
// Punctuation that commonly trails a URL in prose ("join: <url>.") but is not
// part of the address — peel it off so the tapped link stays valid.
const TRAILING_PUNCT = /[.,;:!?)\]}'"]+$/;

export interface TextPart {
    text: string;
    isUrl: boolean;
}

export function splitTextWithUrls(input: string): TextPart[] {
    if (!input) {
        return [];
    }
    return input
        .split(URL_SPLIT)
        .filter((part) => part.length > 0)
        .map((part) => ({ text: part, isUrl: URL_TEST.test(part) }));
}

/** Split a URL token into the tappable address and any trailing prose punctuation. */
export function stripTrailingPunctuation(url: string): { url: string; trailing: string } {
    const trailing = url.match(TRAILING_PUNCT)?.[0] ?? "";
    return { url: trailing ? url.slice(0, -trailing.length) : url, trailing };
}
